<!-- components/MyModal.vue -->
<template>
  <teleport to="body">
    <div v-if="visible" class="modal-mask">
      <div class="modal-container">
        <div class="top-div">
          <div class="edit-title">{{ titleValue }}</div>
          <div class="icon-close" @click="$emit('close')">x</div>
        </div>
        <div class="conton-div-bottom">
          <slot></slot>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'ModalEI',
  props: ['visible', 'titleValue'],
  emits: ['update:visible'],
  watch: {
    visible(newVal) {
      if (newVal) document.body.style.overflow = 'hidden'
      else document.body.style.overflow = ''
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.edit-title {
  font-size: 16px;
  font-weight: 500;
  color: #2a2a2a;
  cursor: context-menu;
}

.top-div {
  display: flex;
  border-radius: 20px 20px 0px 0px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding-left: 15px;
  padding-right: 15px;
  width: 100%;
  border-bottom: 1px solid rgb(212 212 212);
  height: 45px;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.15);
}

.icon-close {
  font-weight: 600;
  cursor: pointer;
}

.conton-div-bottom {
  padding: 15px 15px 5px 15px;
}
</style>